import axiosInstance from "./axiosInstance";

export const getAnualidades = async (page=1, limit=10) => {
    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/anualidad?page=${page}&limit=${limit}`,
        { withCredentials: true }
    );
}

export const createAnualidad = async (data) => {
    return await axiosInstance.post(
        `${process.env.REACT_APP_BASE_URL}/anualidad`,
        data,
        { withCredentials: true }
    );
}
export const updateAnualidad = async (data) => {
    return await axiosInstance.put(
        `${process.env.REACT_APP_BASE_URL}/anualidad`,
        data,
        { withCredentials: true }
    );
}
export const deleteAnualidad = async (id) => {
    return await axiosInstance.delete(
        `${process.env.REACT_APP_BASE_URL}/anualidad?idAnualidad=${id}`,
        { withCredentials: true }
    );
}